'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _styles = require('../settings/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    width: '80%',
    maxWidth: '350px',
    margin: '0 auto',
    backgroundColor: _colors2.default.white,
    borderRadius: '4px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    boxShadow: _styles2.default.depthShadows[0]
  },
  content: {
    padding: '24px 16px',
    color: _colors2.default.primaryText
  },
  footer: {
    padding: '8px 16px',
    backgroundColor: _colors2.default.theme,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: _colors2.default.white,
    textTransform: 'uppercase'
  },
  header: {
    color: _colors2.default.secondaryText,
    fontSize: '24px',
    fontWeight: 'bolder',
    margin: '0 0 16px'
  }
};
module.exports = exports.default;